export enum SsmoTask {
  KYB = 'KYB',
  KYC = 'KYC',
  CONTRACT_SIGNING = 'CONTRACT_SIGNING',
  MENU_SUBMISSION = 'MENU_SUBMISSION',
  OPENING_TIMES = 'OPENING_TIMES',
}

export enum SsmoStepsIdentifiers {
  OpeningHours = 'opening-hours',
  ContractDetails = 'contract-details',
  SignContract = 'sign-contract',
  UploadMenu = 'product-list',
  BusinessDetails = 'business-details',
  ServicePricing = 'service-pricing',
  DeviceSelection = 'device-selection',
  Review = 'review-info',
  MenuPhotoShoot = 'menu-photo-shoot',
  KYC = 'kyc',
  KybDataSubmition = 'kyb-data-submission',
  KybDataVerification = 'kyb-data-verification',
}

export enum SsmoTaskStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  BLOCKED = 'BLOCKED',
  FAILED = 'FAILED',
}

export enum SsmoStepStatus {
  OPEN = 'OPEN',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export const STATUSES_INTL_ID = 'self-serve-sign-up.onboarding-page.stages-view.statuses';

export const taskStatusToSubtitleMapping: Record<SsmoTaskStatus, string> = {
  [SsmoTaskStatus.IN_PROGRESS]: `${STATUSES_INTL_ID}.in-progress`,
  [SsmoTaskStatus.COMPLETED]: `${STATUSES_INTL_ID}.completed`,
  [SsmoTaskStatus.FAILED]: `${STATUSES_INTL_ID}.failed`,
  [SsmoTaskStatus.OPEN]: '',
  [SsmoTaskStatus.BLOCKED]: '',
};

export const BUSINESS_DETAILS_LOCAL_STORAGE_ID = 'businessDetails';
export const DEVICE_PREFERENCES_LOCAL_STORAGE_ID = 'devicePreferences';
export const COMMISION_PREFENCES_LOCAL_STORAGE_ID = 'commissionPreferences';
export const MENU_PHOTOSHOOT_OPTIONS_LOCAL_STORAGE_ID = 'menuPhotoShootOptionPreferences';
